var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.merchantNotifications),function(notification){return _c('div',{key:notification.action,staticClass:"mb-md"},[_c('PushNotification',{attrs:{"notifications":_vm.pushNotifications,"action":notification.action,"title":notification.title,"text":notification.text}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }